import React from 'react'

import './style.scss'

export const Grid = ({ children }) => (
  <div className="l-flex-row">{children}</div>
)

export const GridItem = props => (
  <div
    className={
      'grid__item l-flex-col--xs-' + props.columns + ' ' + props.className
    }
  >
    {props.children}
  </div>
)

GridItem.defaultProps = {
  columns: '12',
}
